import withReduxForm from '../ReduxFormFieldWrapper';
import PlainTextField from '../../PlainTextField/PlainTextField';

export default withReduxForm()(PlainTextField);
